import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const SESSION_KEY = "vita_visitor_session";

function getSessionId() {
  let sid = sessionStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = "s_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

/**
 * VisitorTracker — petit composant invisible qui pingue /api/public/track
 * à chaque changement de route. N'envoie rien sur les pages admin (privées).
 */
export default function VisitorTracker() {
  const loc = useLocation();
  useEffect(() => {
    if (loc.pathname.startsWith("/admin")) return;
    const body = {
      path: loc.pathname + (loc.search || ""),
      referrer: document.referrer || null,
      session_id: getSessionId(),
    };
    axios.post(`${BACKEND_URL}/api/public/track`, body).catch(() => {});
  }, [loc.pathname, loc.search]);
  return null;
}
